module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("HAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("WO")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STOLEN FROM AFRICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "602",
      "src": "images/2-1a_BW_2_fmt.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A depiction of enslaved Africans aboard the ")]), _vm._v("Wildfire"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" circa 1860.")]), _vm._v(" "), _c('span', {
    staticClass: "cap-credit"
  }, [_vm._v("[Library of Congress, Prints & Photographs Division, LC-USZ62-19607]")])]), _vm._v(" "), _c('p', {
    staticClass: "EPF"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("If slavery be wrong, it is justified by the example of all the world.… In all ages one half of mankind have been slaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—C")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("HARLES")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(" P")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("INCKNEY")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("DELEGATE")]), _c('span', {
    staticClass: "ePub-B"
  }), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("TO")]), _c('span', {
    staticClass: "ePub-B"
  }), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(" C")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ONSTITUTIONAL")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(" C")]), _c('span', {
    staticClass: "ePub-SC-B"
  }, [_vm._v("ONVENTION")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(", 1787")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("When I looked round the ship too and saw a large furnace of copper boiling, and a multitude of black people of every description chained together, every one of their countenances expressing dejection and sorrow, I no longer doubted of my fate; and, quite overpowered with horror and anguish, I fell motionless on the deck and fainted. When I recovered a little, I found some black people about me.… I asked them if we were not to be eaten by those white men with horrible looks, red faces, and long hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("HE")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" I")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("NTERESTING")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" N")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("ARRATIVE")]), _c('span', {
    staticClass: "ePub-BI"
  }), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "ePub-BI"
  }), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" L")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("IFE")]), _c('span', {
    staticClass: "ePub-BI"
  }), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" O")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("LAUDAH")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" E")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("QUIANO")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("OR")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" G")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("USTAVUS")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" V")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("ASSA")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(" A")]), _c('span', {
    staticClass: "ePub-SC-BI"
  }, [_vm._v("FRICAN")]), _c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v(",")]), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v(" 1789")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("The boy sat in a tree, high above the African jungle. While the adults were working in nearby fields, it was his job to call out a warning if dangerous animals or strangers approached. Once, he saw a man sneak into the village and try to take some children. Raising the alarm, the boy yelled at the top of his lungs until the village adults came. They caught the stranger and tied him up. Everyone in this African village was safe for the day.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The next time, the boy—no more than ten years old—was not so lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“One day, when all our people were gone out to their works as usual, and only I and my dear sister were left to mind the house,” he later recalled, “two men and a woman got over our walls, and in a moment seized us both, and, without giving us time to cry out, or make resistance, they stopped our mouths, and ran off with us into the nearest wood.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No alarm was raised this time. The strangers gagged both children, tied them up, and bundled them away before anyone knew they were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Kidnapped!")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("After a few days’ travel, the boy was sold as a servant to another village. Separated from his sister, he didn’t know if he would ever see her or the rest of his family again. Although he was treated fairly well by his masters, the small boy had only one wish—to return home.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "418",
      "src": "images/2-2a_BW_2_fmt.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A group of captive Africans are taken to a slave ship by Arab traders in an illustration by Frederic Shoberl, published in ")]), _vm._v("The World in Miniature: Africa"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" (1821). ")]), _c('span', {
    staticClass: "cap-credit"
  }, [_vm._v("[Library of Virginia]")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then, while tending chickens one day, he killed one by accident. Afraid of being punished, he ran away. When caught, he was sold again. The men who took him carried him farther and farther away from his home. Moving through one strange village after another, the boy no longer understood the languages he heard.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Eventually, the boy was taken to the seacoast and sold yet again. Nearly six months had passed since he had been snatched from his village. After being traded once more, he was brought aboard a large, strange ship riding at anchor.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "img11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "430",
      "src": "images/2-3a_2_fmt.jpeg",
      "width": "550"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The ")]), _vm._v("Rochelle,"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" a French slave ship, circa 1741. ")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I was soon put down under the decks, and there I received such a salutation in my nostrils as I had never experienced in my life,” the boy recalled. “With the loathsomeness of the stench … I became so sick and low that I was not able to eat.… I now wished for the last friend, death, to relieve me; but soon, to my grief, two of the white men offered me eatables; and, on my refusing to eat, one of them held me fast by the hands, and laid me across I think the windlass, and tied my feet, while the other flogged me severely.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It is hard to imagine the terror experienced by a small boy caught like this, sometime in the 1750s. The man who later told that story was Olaudah Equiano, who also went by the name Gustavus Vassa.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But the nightmare was just beginning for him and the other kidnapped Africans forced belowdecks. Descending a ladder, they were assaulted by the stench of human waste and death. Next, they had to survive the trip across the Atlantic, the voyage known as the Middle Passage—the longest of three legs in the so-called Triangle Trade in which the first leg was European goods carried to Africa and exchanged for captives. After bringing slaves to the Americas, the last leg saw the ships return to Europe with raw materials or finished products, such as rum and molasses.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("During the Middle Passage, the captives were all chained and pressed tightly together into a hellish space. Usually, they had no more than eighteen inches—barely room to turn over—above them. It was like being forced into a coffin. Many did not survive the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In this floating death box, the transatlantic journey took from six to ten weeks. Food for the captives was scarce. Sometimes local items were available while the ships continued to trade along the African coast until the holds were filled with human cargo. During the long voyage, the meal offered to captives was usually little more than a worm-ridden gruel—a thin, watery boiled cereal—or a concoction called “dab-a-dab,” a mash of beans, rice, and corn.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sometimes, the desperate people in chains tried to strike back at the outnumbered crew. Resistance was futile. The white men had all the guns, whips, and swords. Locked together—frightened, weak, sick—many died from disease or starvation. The dead bodies were tossed overboard. Sharks followed the slave ships and attacked these bodies in a feeding frenzy that left the sea churning with blood.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Captains used the terror aroused by the ever-present sharks to enforce order. To strike fear among the captives, some captains would tie a woman with rope and lower her into the water. Her fellow captives would see the half-eaten remains of the victim raised from the ocean as a gruesome lesson in obedience. The cruel, sadistic methods of the slavers had one goal—to keep the captives alive but disciplined.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When this frightful journey from Africa’s west coast was over, the survivors were usually delivered to the islands of Jamaica and Barbados or to Brazil, in South America. Before the captives were off-loaded, the crew would clean them. Like farm animals being prepared for judging at a county fair, the captives were made to look healthy. Ointments were applied to the oozing sores left by the tight shackles. Hair was darkened—gray hair or any other signs of age would reduce the value of the captive. Bodies were oiled to make them appear healthier.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All that mattered was fetching a good price for their human cargo in “the scramble.” That was the rush of buyers to grab the best of the newly arrived captives. Every one of the chained prisoners was crudely inspected. Men’s muscles—in their backs, arms, legs—were prodded and poked, tested for strength. For women, it meant checking their bodies, including their breasts and teeth, and posture. All sense of modesty or innocence was stripped away. Some were taken away to be “seasoned,” trained in a slave’s duties. Others were sent on to ships sailing for the slave ports of colonial America.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("After spending nearly twenty years in slavery in America, Olaudah Equiano was able to purchase his freedom and later wrote an autobiography, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Interesting Narrative of the Life of Olaudah Equiano")]), _vm._v(","), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" or Gustavus Vassa, the African.")]), _vm._v(" Published in London in 1789, his memoir told of being captured, carried across the ocean to Barbados, and sold to a merchant sea captain. His book was one of the first accounts by a former enslaved person ever published.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Although a few historians have recently cast doubt on some of the details of Olaudah Equiano’s life story, the majority of his account has been verified. His depiction of the horrors of being stolen from his village, his captivity on the ship, the Middle Passage, and his life among the enslaved was a true picture. The same, and much worse, had happened to millions of people stolen from Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His story also helped change people’s minds. In England, Equiano’s book created a wave of public opposition to slavery. It helped lead to passage of the law that abolished the British slave trade in 1807.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By the time Equiano published his book, slave ships had carried more than 160,000 Africans to America’s Chesapeake colonies, 140,000 to the Carolinas and Georgia, and 30,000 to the northern colonies. Some 330,000 enslaved people were brought to the future United States of America, starting in the earliest colonial days to 1775, just before the American Revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("These numbers were a small fraction of the millions of Africans stolen and brutally shipped to Spanish, Dutch, French, and British colonies in the Caribbean—especially Jamaica and Barbados—and the more than two million carried to the Portuguese colony of Brazil, where sugar plantations required vast numbers of workers.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "656",
      "src": "images/p.25_olaudah_fmt.jpeg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A portrait of Olaudah Equiano, or Gustavus Vassa, whose published story helped launch the abolition movement. ")]), _c('span', {
    staticClass: "cap-credit"
  }, [_vm._v("[Library of Congress, Prints & Photographs Division, LC-USZ62-54026]")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The multitudes of Africans violently wrenched from their families and villages in this murderous global business is mind-boggling.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("According to the best estimates, during the almost four hundred years of the African slave trade from the late fifteenth into the nineteenth century, 12.4 million people were loaded onto slave ships and carried across the Atlantic. “Along the dreadful way, 1.8 million of them died,” historian Marcus Rediker recorded, “their bodies cast overboard to the sharks that followed the ships. Most of the 10.6 million who survived were thrown into the bloody maw of a killing plantation system.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The catastrophic death toll in the New World was part of a profitable system that was far from unique. Slavery is as old as humanity. It was an ancient and global practice that continues in parts of the world today as boys and girls continue to be sold into forced labor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For many years, the notion that slavery had always been practiced—and, more important, approved by the Bible—was used by many Americans to defend slavery. Charles Pinckney of South Carolina, one of the delegates at the Constitutional Convention in 1787, said, “If slavery be wrong, it is justified by the example of the world.… In all ages one half of mankind have been slaves.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Throughout world history, slavery has taken on many forms, existing among the earliest societies. All the so-called great civilizations functioned with slavery in different forms. Ancient Egypt, Greece, and Rome had some type of slavery, usually based on the captivity of people conquered in wars. Long before Europeans came to the Americas, native nations such as the Aztec and Inca enslaved people, too.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The use of forced slave labor by Europeans began almost as soon as the first Spanish settlers arrived in the New World. The first groups that Europeans enslaved in the Americas were not Africans but the people called “Indians” by Columbus. They were forced to work in Spanish mines and large plantations in the Americas. Armed with guns, steel swords, and dogs wearing armor and spiked collars, the Spanish quickly conquered native people such as the Carib, Arawak, and Inca and forced them to dig for gold and silver and work on large estates. It was prison labor under threat of constant violence. A native who failed to bring enough gold out of a mine might have a hand chopped off. Spanish treasure galleons were soon sailing home loaded with riches from mines in Mexico and Peru. The Spanish built a global golden empire on these treasures, certain that Heaven had blessed them.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "714",
      "src": "images/2-4a_BW_copy_fmt.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Published in 1788, this illustration of the British slave ship ")]), _vm._v("Brookes"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" showed how tightly the captives were packed and was widely used by abolitionists to attack the slave trade. ")]), _c('span', {
    staticClass: "cap-credit"
  }, [_vm._v("[Library of Congress, Rare Book and Special Collections Division, LC-USZ62-44000]")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The natives, of course, were not so fortunate. They were quickly dying. One reason was the harsh labor conditions. But another was an invisible killer: the Spanish and other European explorers brought deadly contagious diseases, like smallpox, to the Americas. Native people had little natural resistance, or immunity, to these new diseases. No one knows exactly how many native people died after Europeans arrived in the New World, but the estimated percentages are staggering—epidemics wiped out as many as 90 percent of some native communities.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When a Spanish priest saw how cruelly the natives were treated and how rapidly they were dying, he recommended a solution. This priest, Bartolomé de las Casas, suggested using imported African laborers instead of oppressing the native people. In 1518, the Spanish government created a system that licensed slave traders to bring Africans to the New World. This solution merely exchanged one deadly system for another.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As the Spanish and other European colonizers of the New World switched from a frenzied hunt for gold and silver to the production of cash crops like tobacco, rice, and sugar, the demand for African workers exploded. Wherever Europeans arrived to set up New World colonies—from Canada down to Chile and Peru and across the Caribbean—slavery became key to the conquest of the Americas.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In later times, coal and oil would drive the great engines of American progress. They were the fuel that powered the railroads, factories, and machinery of the Industrial Age. But in early America, racial slavery powered progress. It made the system work and created great fortunes. Slavery was not a sideshow to the settlement and development of America but a central feature.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The first shipload of captive Africans to arrive in the future United States came to Jamestown, Virginia—the first permanent English settlement in America—in August 1619. John Rolfe, famed for his role in making tobacco a successful cash crop in Virginia and later marrying the woman known as Pocahontas, recorded that “20 and odd” Africans were brought to the settlement. Recent research suggests they may have been taken from Angola by Portuguese slave traders and then captured at sea by British pirates flying the Dutch flag, who then sold them in Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("These Africans were actually purchased as “indentured servants” rather than slaves. An indentured servant was typically someone who agreed to work for several years in exchange for his or her passage, eventual freedom, and the promise of some land. In colonial America, both white and black people came as indentured servants, including some of those who sailed aboard the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mayflower")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("After their period of indenture was over, they were released, if they were still alive. The death rate among indentured servants in colonial America was very high. Malnutrition, lack of medical care, diseases like malaria and yellow fever, harsh working conditions, severe punishments, and wars with local native people all took a heavy toll.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Some indentured servants came by choice. But many of those shipped to America were kidnapped children, orphans, and convicted criminals—meaning they had no say in the matter. For many years, indentured servants filled America’s need for workers. By the 1630s, most people in colonial Virginia—whether they had chosen their life or not—were indentured servants.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then something changed. By the early 1700s, fewer white Europeans were willing to accept the hardships of servitude in America. Frightening tales of death, disease, and the threat of “savage Indians” made many unwilling to risk the long ocean crossing and uncertain future. In European countries, the quality of life was also rapidly improving. Fewer wars and better sanitation and medical practices meant higher living standards. As conditions improved, fewer Europeans were willing to take the gamble of a servant’s life in America.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But the American demand for field workers and household servants surged, especially in places like South Carolina, where rice production was booming. Along with sugar and tobacco, rice demands intense, backbreaking labor. The planters needed more slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("African slavery in America grew quickly because enslaved people were cheaper to buy than white servants. Africans were also thought to be physically strong and capable team workers. Accustomed to cooperative agriculture in which whole villages often farmed together, many Africans were used to working in large groups, the most efficient method for large American plantations. And many Europeans and Americans thought—incorrectly—that Africans were less likely to die from tropical diseases since they came from a tropical climate.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Because of their skin color and because few Africans spoke English, it was far more difficult for them to run away and mix into society, unlike white servants. Enslaved American Indians had been able to escape more easily since they were usually familiar with the local area and could return to their own people.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But one fact stood above all: Africans were enslaved for life. Unlike indentured servants who might eventually be freed, a slave was a slave forever—unless freed for some reason by an owner. All of these factors made the African slave trade a booming international business in the early 1700s.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By 1776, when Thomas Jefferson wrote the Declaration of Independence, there were 500,000 African Americans enslaved among the 2.5 million people in the thirteen colonies.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That great year of independence for America was a little less than ten years after George Washington purchased four boys named Jack, Adam, William, and Frank.")]), _vm._v(" "), _c('div', {
    staticClass: "PAGE-BREAK"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "DOCH",
    attrs: {
      "id": "t2"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#t_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLAVERY IN AMERICA TIME LINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "DOCDA"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#t_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1705–1776")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1705")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("Massachusetts declares marriage between whites and blacks illegal. Virginia rules that slaves are “real estate,” restricts their travel, and calls for stricter penalties for marriage or sexual relations between the races, which had been illegal since 1691.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1713")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("Quaker opposition to slavery in Philadelphia continues to grow; some Quakers develop a plan for emancipating slaves and returning them to their native lands in Africa.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1739")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("The Stono Rebellion, a violent slave uprising, is put down in South Carolina. Thirty white people and forty-four black people die in the violence.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1754")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("John Woolman, a Philadelphia Quaker and tailor, publishes "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Some Considerations on the Keeping of Negroes: Recommended to the Professors of Christianity of Every Denomination.")]), _vm._v(" Arguing that slavery is unchristian and cruel, it becomes the most widely distributed antislavery work before the Revolution.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1758")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("Philadelphia Quakers stop buying and selling slaves and press for outright abolition of slavery. Quakers in other states and in London follow suit.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1770")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("Anthony Benezet, a Quaker schoolteacher, begins a school for free blacks in Philadelphia and helps hundreds of black people—some free and others enslaved—learn to read and write.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1773–1779")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("New England slaves petition colonial legislatures for freedom.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1775")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("After the American Revolution begins in April, Lord Dunmore, the royal governor of Virginia, offers freedom to any enslaved people or indentured servants who escape and join the king’s forces. Black patriots fight in all of the early battles of the Revolution. Other escaped slaves join the British army. General Washington initially refuses to allow blacks to serve but later reverses that policy. Black soldiers eventually account for between 10 and 20 percent of the Continental Army and Navy.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "DOCCL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1776")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "DOCCL3"
  }, [_vm._v("The Continental Congress adopts the Declaration of Independence in Philadelphia. During the debates, Congress removes a passage in Thomas Jefferson’s draft that condemns the slave trade.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba71cd12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0